// extracted by mini-css-extract-plugin
export default {"articles":"Articles_articles__You7N","article":"Articles_article__T5yq7","articleSingle":"Articles_articleSingle__QHDeP","btnBack":"Articles_btnBack__uneWT"};